module.exports = __webpack_public_path__ + "08_long_beige.c79985b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_long_beige.png
// module id = leAj
// module chunks = 0